module.exports = __webpack_public_path__ + "img/ic_warning.838bde1d.svg";